export default __webpack_public_path__ + "static/media/pdf-logo.ee314ec7.jpg";